import type NonEmptyText from '../non-empty-text';
import type Workflow from './workflow';
import { assertIsInstanceOfNonEmptyText, assertIsInstanceOfWorkflow } from '../assertions';

interface IState {
	readonly key: NonEmptyText;
	readonly workflow: Workflow;
}

export default class State implements IState {
	public get key(): NonEmptyText {
		return this.#key;
	}

	public get workflow(): Workflow {
		return this.#workflow;
	}

	#key: NonEmptyText;
	#workflow: Workflow;
	public constructor({ key, workflow }: IState) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
		assertIsInstanceOfWorkflow(workflow);
		this.#workflow = workflow;
	}
}
